import { AppContext } from './AppContext';
import { useAppInitialization } from '../hooks/useAppInitialization';

export function AppProvider({ children }) {
  const appData = useAppInitialization();

  return <AppContext.Provider value={appData}>{children}</AppContext.Provider>;
}
